"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { motion, Variants } from "framer-motion";
import { Container, SectionSubHeading, SectionTitle, TeamCard } from "@/components";
import { teamMembers } from "@/data/TeamData";
interface TeamCrewProps {
  currentSlug: string;
}
const item: Variants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: (i: number) => ({
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      delay: i * 0.08,
      ease: [0.22, 1, 0.36, 1]
    }
  })
};

// Cross-navigation to the rest of the roster. Reuses the shared TeamCard so the
// cards match the About page's "Meet Our Team" section exactly.
const TeamCrew = t0 => {
  const $ = _c(19);
  const {
    currentSlug
  } = t0;
  let T0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== currentSlug) {
    const rest = teamMembers.filter(m => m.slug !== currentSlug);
    t5 = "bg-background py-14 md:py-20";
    T0 = Container;
    t3 = "px-4 lg:px-10";
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <div className="space-y-3"><SectionSubHeading subtitle="The Rest Of The Crew" className="text-primary" /><SectionTitle title="MEET THE OTHERS." /></div>;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    t1 = "mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 md:mt-16";
    t2 = rest.map(_temp);
    $[0] = currentSlug;
    $[1] = T0;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
  } else {
    T0 = $[1];
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
    t5 = $[6];
  }
  let t6;
  if ($[8] !== t1 || $[9] !== t2) {
    t6 = <div className={t1}>{t2}</div>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== T0 || $[12] !== t3 || $[13] !== t4 || $[14] !== t6) {
    t7 = <T0 className={t3}>{t4}{t6}</T0>;
    $[11] = T0;
    $[12] = t3;
    $[13] = t4;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t5 || $[17] !== t7) {
    t8 = <section className={t5}>{t7}</section>;
    $[16] = t5;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  return t8;
};
export default TeamCrew;
function _temp(member, i) {
  return <motion.div key={member.id} variants={item} custom={i} initial="hidden" whileInView="visible" viewport={{
    once: true,
    amount: 0.3
  }}><Link href={`/about-us/${member.slug}`} aria-label={`View ${member.name}`} className="block h-80 transition-transform duration-300 hover:-translate-y-1"><TeamCard member={member} index={teamMembers.indexOf(member)} /></Link></motion.div>;
}